import { store } from '../redux/store'
import { toast } from 'react-toastify'
import {
  isLoading,
  setIsNewNotification,
  setNotificationData,
  setStripeConfirmation,
  setTopTokenPriceChange,
  // setUser,
} from '../redux/userReducer'
import axios from 'axios'
import { validateAccessToken } from 'utils/validation'
import { checkRateLimit } from 'utils/rateLimiter'

const apiUrlEc2 = process.env.REACT_APP_BASE_ENDPOINT

////////////////////////
// STRIPE CONFIRMATION
////////////////////////

// POST / https://api.astrotek.app/api/stripe_confirmation
export async function getMembershipStatus(email: string, accessToken: string) {
  checkRateLimit(accessToken, 20, 60000); // 20 requests per minute per token
  // Validate email
  if (!email || typeof email !== 'string') {
    console.error('Please enter an email address');
    return null;
  }
  
  const trimmedEmail = email.trim();
  if (trimmedEmail.length === 0) {
    console.error('Please enter an email address');
    return null;
  }
  
  // Basic email format validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(trimmedEmail)) {
    console.error('Please enter a valid email address');
    return null;
  }
  
  const validToken = validateAccessToken(accessToken);
  
  try {
    store.dispatch(isLoading(true));
    
    const payload = {
      email: trimmedEmail,
    };
    
    const headers = {
      'Authorization': `Bearer ${validToken}`,
      'Content-Type': 'application/json'
    };
    
    const data = await axios.post(`${apiUrlEc2}stripe_confirmation`, payload, {
      headers,
    });
    
    if (data?.status === 200) {
      store.dispatch(setStripeConfirmation(data?.data));
    }
    
    return data;
  } catch (e) {
    console.error('Membership check error');
    
    // Sanitize error for user
    if (axios.isAxiosError(e)) {
      if (e.response?.status === 401) {
        console.error('Authentication failed')
      } else if (e.response?.status === 400) {
        toast.error('Invalid email provided')
      } else {
        toast.error('Unable to check membership status with provided email')
      }
    } else {
      toast.error('Unable to check membership status with provided email')
    }
  } finally {
    store.dispatch(isLoading(false));
  }
}






//////////////////////////
// GET NOTIFICATION DATA 
//////////////////////////

// POST / https://api.astrotek.app/api/transfers
export async function getNotificationData(accessToken: string) {
  checkRateLimit(accessToken, 20, 60000); // 20 requests per minute per token
  const validToken = validateAccessToken(accessToken);
  
  try {
    const headers = {
      'Authorization': `Bearer ${validToken}`,
      'Content-Type': 'application/json'
    };
    
    const data = await axios.get(`${apiUrlEc2}transfers`, { headers });
    
    if (data?.status === 200) {
      const prevNotificationData = store.getState().user.notificationData;
      if (prevNotificationData?.length < data?.data?.length) {
        store.dispatch(setIsNewNotification(true));
      }
      store.dispatch(setNotificationData(data?.data));
    }
    
    return data;
  } catch (e) {
    console.error('Notification data error');
    
    // Sanitize error for user
    if (axios.isAxiosError(e)) {
      if (e.response?.status === 401) {
        toast.error('Error retrieving notification data')
      } else {
        toast.error('Unable to retrieve notifications.')
      }
    }
    return null;
  }
}





//////////////////////////////
// GET TOP TOKEN PRICE CHANGE 
//////////////////////////////

// POST / top token price change
export async function getTopTokenPriceChange(accessToken: string) {
  checkRateLimit(accessToken, 20, 60000); // 20 requests per minute per token
  const validToken = validateAccessToken(accessToken);
  
  try {
    const headers = {
      'Authorization': `Bearer ${validToken}`,
      'Content-Type': 'application/json'
    };
    
    const data = await axios.get(`${apiUrlEc2}top_tokens_price_change`, {
      headers,
    });
    
    store.dispatch(setTopTokenPriceChange(data?.data));
    return data;
  } catch (e) {
    // Sanitize error for user
    if (axios.isAxiosError(e)) {
      if (e.response?.status === 401) {
        console.error('Authentication failed')
      } else {
        // toast.error('Unable to fetch token price changes. Please try again.')
      }
    } else {
      toast.error('Unable to fetch token price changes. Please try again.')
    }
    return null;
    // toast.error('Unable to fetch token price changes. Please try again.')
  }
}





//////////////////////////////
// UPDATE TOS
//////////////////////////////

// POST / update tos based on username
export async function updateTos(username: string, accessToken: string) {
  checkRateLimit(accessToken, 20, 60000); // 20 requests per minute per token
  // Validate username
  if (!username || typeof username !== 'string') {
    console.error('Username is required')
    return null;
  }
  
  const trimmedUsername = username.trim();
  if (trimmedUsername.length === 0) {
    console.error('Username cannot be empty')
    return null;
  }
  
  const validToken = validateAccessToken(accessToken);
  
  try {
    const headers = {
      'Authorization': `Bearer ${validToken}`,
      'Content-Type': 'application/json'
    };
    
    const data = await axios.post(`${apiUrlEc2}update_tos`, {
      username: trimmedUsername
    }, {
      headers,
    });
    
    return data;
  } catch (e) {
    console.error('Update TOS error');
    
    // Sanitize error for user
    if (axios.isAxiosError(e)) {
      if (e.response?.status === 401) {
        console.error('Authentication failed')
      } else if (e.response?.status === 400) {
        toast.error('Invalid username provided')
      } else {
        toast.error('Unable to update terms of service. Please try again.')
      }
    } else {
      toast.error('Unable to update terms of service. Please try again.')
    }
    return null;
  }
}
